import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';

const ICON_MAIL = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`;

const ICON_PHONE = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>`;

const ICON_WA = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.881 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`;

const ICON_PIN = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>`;

function iconEl(className: string, svg: string): HTMLElement {
  const span = document.createElement('span');
  span.className = className;
  span.innerHTML = svg;
  return span;
}

export function renderCta(target: HTMLElement): void {
  const { contact } = SITE;

  const emailGrid = createEl('div', { className: 'sv-contact-email-grid' });
  contact.emails.forEach((row, i) => {
    emailGrid.appendChild(
      createEl(
        'a',
        {
          className: `sv-contact-email-card sv-contact-email-card--tone-${i}`,
          href: `mailto:${row.address}`,
        },
        [
          iconEl('sv-contact-email-card__glyph', ICON_MAIL),
          createEl('span', { className: 'sv-contact-email-card__role' }, [row.label]),
          createEl('span', { className: 'sv-contact-email-card__addr' }, [row.address]),
        ]
      )
    );
  });

  const mailCol = createEl('div', { className: 'sv-contact-col sv-contact-col--mail' }, [
    createEl('div', { className: 'sv-contact-section-head' }, [
      iconEl('sv-contact-section-head__glyph', ICON_MAIL),
      createEl('h3', { className: 'sv-contact-section-head__title' }, ['Correo']),
    ]),
    emailGrid,
  ]);

  const waLink = document.createElement('a');
  waLink.className = 'sv-contact-phone-panel__wa';
  waLink.href = `https://wa.me/${contact.whatsAppDigits}`;
  waLink.target = '_blank';
  waLink.rel = 'noopener noreferrer';
  waLink.appendChild(iconEl('sv-contact-phone-panel__wa-icon', ICON_WA));
  waLink.appendChild(document.createTextNode(' WhatsApp'));

  const phonePanel = createEl('div', { className: 'sv-contact-phone-panel' }, [
    createEl('div', { className: 'sv-contact-phone-panel__head' }, [
      iconEl('sv-contact-phone-panel__glyph', ICON_PHONE),
      createEl('p', { className: 'sv-contact-phone-panel__label' }, [contact.phoneWhatsAppLabel]),
    ]),
    createEl(
      'a',
      {
        className: 'sv-contact-phone-panel__tel',
        href: `tel:${contact.phoneTel}`,
      },
      [contact.phoneDisplay]
    ),
    createEl('div', { className: 'sv-contact-phone-panel__wa-row' }, [waLink]),
  ]);

  const phoneCol = createEl('div', { className: 'sv-contact-col sv-contact-col--phone' }, [phonePanel]);

  const layout = createEl('div', { className: 'sv-contact-layout' }, [mailCol, phoneCol]);

  const locationBar = createEl('div', { className: 'sv-contact-location-bar' }, [
    iconEl('sv-contact-location-bar__glyph', ICON_PIN),
    createEl('span', { className: 'sv-contact-location-bar__text' }, [contact.location]),
  ]);

  const contactWrap = createEl('div', { className: 'sv-contact-wrap' }, [layout, locationBar]);

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-section--tight sv-cta-band',
      id: 'contacto',
      'aria-labelledby': 'cta-title',
    },
    [
      createEl('div', { className: 'sv-inner sv-cta-band__inner' }, [
        createEl('h2', { className: 'sv-cta-band__title', id: 'cta-title' }, [SITE.cta.title]),
        createEl('p', { className: 'sv-cta-band__subtitle' }, [SITE.cta.subtitle]),
        contactWrap,
        createEl(
          'a',
          {
            className: 'sv-btn sv-btn--primary sv-cta-band__btn',
            href: '#inicio',
          },
          [SITE.cta.button]
        ),
      ]),
    ]
  );
  target.appendChild(section);
}
